import { cn } from '@/lib/utils';

interface SpinnerProps {
    size?: number | string;
    /** Stroke width in the same 44-unit viewBox MUI's CircularProgress used,
     *  so migrated call sites keep their thickness values' meaning. */
    thickness?: number;
    className?: string;
}

export function Spinner({ size = 24, thickness = 3.6, className }: SpinnerProps) {
    const radius = (44 - thickness) / 2;
    const circumference = 2 * Math.PI * radius;

    return (
        <svg
            className={cn('animate-spin text-current', className)}
            width={size}
            height={size}
            viewBox="0 0 44 44"
            fill="none"
            role="progressbar"
        >
            <circle cx="22" cy="22" r={radius} stroke="currentColor" strokeWidth={thickness} opacity="0.25" />
            <circle
                cx="22"
                cy="22"
                r={radius}
                stroke="currentColor"
                strokeWidth={thickness}
                strokeLinecap="round"
                strokeDasharray={`${circumference * 0.25} ${circumference}`}
            />
        </svg>
    );
}
